<template>
	<p>Autenticando...</p>
</template>

<script>
	import { AuthService } from "../services/auth";

	export default {
		data () {
			return {
				authService: new AuthService()
			};
		},

		beforeMount () {
			const urlParams = new URLSearchParams(window.location.search);
			const entries = urlParams.entries();
			const params = Object.fromEntries(entries);
			const paramsStr = JSON.stringify(params);
			localStorage.setItem("params", paramsStr);
			console.log(paramsStr);
		},

		mounted () {
			this.$router.push({ name: "home" });
		}
	};
</script>
